<template>
  <div ref="root" class="relative inline-block text-left">
    <button
        type="button"
        class="inline-flex items-center gap-1 px-3 py-2  text-sm font-medium text-zinc-800 hover:bg-zinc-50"
        @click="toggle"
        :aria-expanded="open.toString()"
        :aria-haspopup="true"
    >
      <span class="select-none">{{ label }}</span>
      <Icon v-if="open" name="expand_less" class="ml-1.5 w-5 h-5 text-zinc-600 text-base pointer-events-none"/>
      <Icon v-else name="expand_more" class="ml-1.5 w-5 h-5 text-zinc-600 text-base pointer-events-none"/>
    </button>

    <transition name="fade-scale">
      <div
          v-if="open"
          class="absolute right-0 mt-2 w-40 bg-white border border-gray-200 rounded-md shadow-lg z-50 focus:outline-none"
          role="menu"
          aria-orientation="vertical"
          aria-labelledby="options-menu"
      >
        <ul class="py-1">
          <li v-for="opt in options" :key="opt.value">
            <button
                @click="select(opt.value)"
                class="w-full text-left px-4 py-2 text-sm flex items-center gap-3 hover:bg-gray-50 transition-colors"
                :class="{'bg-gray-50': modelValue === opt.value}"
                role="menuitem"
            >
              <span class="flex-1">{{ opt.label }}</span>
              <Icon v-if="modelValue === opt.value" name="check" class="w-4 h-4 text-zinc-600 text-base" />
            </button>
          </li>
        </ul>
      </div>
    </transition>
  </div>
</template>

<script setup>
import { ref, computed, watch, onMounted, onBeforeUnmount } from 'vue';
import {Icon} from "@/components/block/icon";

const props = defineProps({
  modelValue: {
    type: String,
    default: 'newest',
  },

  optionsProp: {
    type: Array,
    default: null,
  },
});

const emit = defineEmits(['update:modelValue', 'order-changed']);

const open = ref(false);
const root = ref(null);

const defaultOptions = [
  { value: 'newest', label: 'Newest' },
  { value: 'oldest', label: 'Oldest' },
  { value: 'points', label: 'Points' },
];

const options = computed(() => {
  return props.optionsProp && Array.isArray(props.optionsProp) && props.optionsProp.length > 0
      ? props.optionsProp
      : defaultOptions;
});

const label = computed(() => {
  const found = options.value.find(o => o.value === props.modelValue);
  return found ? found.label : (options.value[0] && options.value[0].label) || 'Newest';
});

function toggle() {
  open.value = !open.value;
}

function close() {
  open.value = false;
}

function select(value) {
  emit('update:modelValue', value);
  emit('order-changed', value);
  close();
}

function onDocumentClick(e) {
  if (!root.value) return;
  if (!root.value.contains(e.target)) {
    close();
  }
}

function onKeyDown(e) {
  if (e.key === 'Escape') {
    close();
  }
}

onMounted(() => {
  document.addEventListener('click', onDocumentClick);
  document.addEventListener('keydown', onKeyDown);
});

onBeforeUnmount(() => {
  document.removeEventListener('click', onDocumentClick);
  document.removeEventListener('keydown', onKeyDown);
});
</script>

